



/* eslint-disable class-methods-use-this */
import { Component, Prop } from "vue-property-decorator";
import CdkClassification from "@dpa-connect/dpa-connect-classification";
import CdkNewsItemDetail from "./CdkNewsItemDetail.vue";
import getPlainText from "./lib/getPlainText";

// REVIEW: data manipulation could possibly be refactored to a utility
// function rather than in a .vue SFC

@Component({
  components: {
    CdkClassification
  }
})
export default class CdkNewsItemDetailText extends CdkNewsItemDetail {
  @Prop({
    type: String,
    required: true
  })
  body!: string;

  /**
   * Emit the plain text to the global event bus, so the sharing options
   * can access it.
   */
  created(): void {
    this.$emit("onPlainText", this.plainText);
  }

  /**
   * Returns a text only version for sharing through clipboards etc.
   */
  get plainText(): string {
    const {
      body,
      by,
      creditLine,
      date,
      dpaContactsText,
      editorialnotes,
      edservices,
      genre,
      hasNotes,
      isEmbargoed,
      links,
      places,
      pubStatus,
      tags,
      time,
      title,
      tooltip
    } = this;

    return getPlainText({
      body,
      by,
      creditLine,
      date,
      dpaContactsText,
      editorialnotes,
      edservices,
      genre,
      hasNotes,
      isEmbargoed,
      links,
      places,
      pubStatus,
      tags,
      time,
      title,
      tooltip
    });
  }
}
